
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  shipmentAddress: {
    id: '',
    name: '',
    addressLine1: ''
  },
  createPackingSlip: false,
  expectedDate: '',
  items: [],
  brandId: '',
  fromWarehouseId: '',
  toWarehouseId: '',
  orderNumber: ''
};

let defaultFilters = {
  projectId: '',
  name: '',
  useFor: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};
